import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import SiteCodeType from 'src/types/SiteCodeType';
import { SelectValue } from 'antd/lib/select';
import { useScriptFetch } from './hooks';

const { Option } = Select;

type WorkUnitScriptFilterProps = {
  data?: SiteCodeType[] | null;
  onScriptUpdate: (value: string) => void;
  isReset?: boolean;
  runId?: string | null;
  setReset: (value: boolean) => void;
};

const WorkUnitScriptFilter: React.FC<WorkUnitScriptFilterProps> = ({
  isReset = false,
  onScriptUpdate,
  runId,
  setReset,
}) => {
  const [filterValue, setFilterValue] = useState<string[]>([]);
  const [{ data }] = useScriptFetch(runId ?? '-1');

  const onScriptFilterChange = (value: SelectValue) => {
    const newValue: string = value ? value.toString() : '';
    setFilterValue(value as string[]);
    onScriptUpdate(newValue);
  };

  useEffect(() => {
    if (isReset) {
      setFilterValue([]);
      setReset(false);
    }
  }, [isReset, setReset]);

  return (
    <div>
      <p style={{ fontSize: '12px', marginBottom: '3px' }}>Script</p>
      <Select
        placeholder="Select Script"
        onChange={onScriptFilterChange}
        value={filterValue}
        showArrow={true}
        allowClear
      >
        {data &&
          data.map((siteDataList: SiteCodeType) => (
            <Option key={`script_${siteDataList.siteCode}`} value={siteDataList.siteCode}>
              {siteDataList.siteCode}
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default WorkUnitScriptFilter;
